<template>
  <div v-drag>
    <a-modal title="提示"
             v-model:visible="dialogVisible"
             width="480rem"
             :bodyStyle="bodyStyle"
              :get-container="getContainer"
             :closable="false"
             :maskClosable="false"
             @cancel="handleClose"
             :footer="null">
      <div class="text_warp"
           v-if="num == 0">
        您已完成全部题目，是否确认提交
      </div>
      <div class="text_warp"
           v-else>
        您还有<span style="color:#FF6147">{{num}}</span>道题未作答，建议继续答题
      </div>
      <div class="btn_warp"
           v-if="num">
        <div @click="save">
          确认提交
        </div>
        <div @click="handleClose">
          继续做题
        </div>
      </div>
      <div class="btn_warp"
           v-else>
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确认提交
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, toRefs } from "@vue/reactivity"
import { useRoute, useRouter } from "vue-router";

const router = useRouter()


let route = useRoute()

let dialogVisible = ref(false)
let num = ref(0)
const setData = (number, bool) => {
  dialogVisible.value = bool
  num.value = number
}
defineProps({
  
  getContainer: Function,
  
})
const bodyStyle = {
  padding: "0rem 0 0 0 ",
  height: '143rem'
}
const emit = defineEmits(['sava'])

const handleClose = () => {
  dialogVisible.value = false
  if(route.path == '/testpaper/card'){
    router.go(-1)
}
  }
   
const save = () => {
  emit('sava')
  // handleClose()
}

defineExpose({
  setData
})
</script>

<style lang="scss" scoped >
 .ant-modal{
top: 25%;
}
.ant-modal-content{
 
border-radius: 32rem;
 
}
.ant-modal-content .ant-modal-header .ant-modal-title{
  color: var(--light-333333, #333);
text-align: center;

 
font-size: 24rem;
font-style: normal;
font-weight: 600;
line-height: 36rem; /* 150% */
 }
.text_warp {
  word-break: break-all;
  font-weight: 500;
  color: #666666 !important;
 
text-align: center;
 
font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30rem; /* 150% */

  text-align: center;
  div {
    display: flex;
    justify-content: center;
  }
}
.btn_warp {
  height: 79rem;
  border-top: 1rem solid #e5e5e5;
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
    &:nth-child(1) {
     color: var(--light-333333, #333);
text-align: center;

 
font-size: 24rem;
font-style: normal;
font-weight: 400;
 
      border-right: 1rem solid #e5e5e5;
      font-size: 24rem;
font-style: normal;
 
    }
    &:nth-child(2) {
      
      
      color: #2196f3;
 
text-align: center;
 
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; /* 150% */
    }
  }
}
</style>